import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  useEffect(() => {
    checkAuth().then(() => {
      // Quem entrou pelo botão de assinar volta do Google direto no checkout.
      const intent = sessionStorage.getItem("tuto_after_auth");
      sessionStorage.removeItem("tuto_after_auth");
      navigate(intent || "/dashboard", { replace: true });
    }).catch(() => {
      navigate("/login?error=auth_failed", { replace: true });
    });
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F7FB]">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-[#003882] border-t-transparent rounded-full animate-spin" />
        <p className="text-[#335480] text-lg font-medium">Autenticando com Google...</p>
      </div>
    </div>
  );
}
